export default {
	title: "Register Address",
    back: 'Back',
	municipality: {
		label: "Town",
		placeholder: "Select your town",
	},
	street: {
		label: "Street",
		placeholder: "Enter your street",
	},
	number: {
		label: "Number",
		placeholder: "Enter your street number",
	},
	button: "Save",
	successMessage: "Address has been saved successfully.",
};
